<template>
  <div class="instagram-container">
    <div class="header-title">Added Social Account</div>
    <div class="list-container">
      <div v-for="type in all" class="type-list" :key="type.title">
        <div class="type-title">{{ type.title }}</div>
        <select-item
          @click.native="itemClick(item)"
          :type="item.type"
          v-for="item in type.items"
          :key="item.id"
          :item="item"
        ></select-item>
      </div>
    </div>
    <div class="bottom-container">
      <el-popover
        placement="top"
        width="230"
        v-model="platformModal"
        trigger="hover"
      >
        <div class="platform-list-container">
          <div class="platform-item" @click="addInsBtnClick">
            <div class="icon ins"></div>
            <div class="text">Instagram</div>
            <div class="right-icon"></div>
          </div>
          <div class="platform-item" @click="addFbPageBtnClick">
            <div class="icon fb"></div>
            <div class="text">Facebook Page</div>
            <div class="right-icon"></div>
          </div>
          <div class="platform-item" @click="addFbGroupBtnClick">
            <div class="icon fb-group"></div>
            <div class="text">Facebook Group</div>
            <div class="right-icon"></div>
          </div>
          <div class="platform-item" @click="addTwitterBtnClick">
            <div class="icon twitter"></div>
            <div class="text">Twitter</div>
            <div class="right-icon"></div>
          </div>
        </div>
        <div slot="reference" class="add-btn">
          <div class="add-icon"></div>
          Add Social Account
        </div>
      </el-popover>
      <!-- <hi-button type="text" @click="showAddInsUser">Add Social Account</hi-button> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../../store/mutation-types";
import selectItem from "../../../components/plan/unlimited_auto/SelectItem";

export default {
  name: "SettingNotificationsPage",
  components: { selectItem },
  model: {
    prop: "model",
    event: "updateValue",
  },
  props: {
    model: {},
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     * 计算列表
     * @returns {Array}
     */
    all() {
      this.user.linkedInstagramList.forEach((l) => {
        if (l.publisherId === this.selectPublisherId) {
          l.type = "active";
        } else {
          l.type = "empty";
        }
      });
      // 根据类型进行分组
      let types = [];
      const limitedPublishers = this.user.linkedInstagramList.filter(
        (l) => !l.isUnlimited && !l.isMember && l.status !== 2
      );
      const unlimitedPublishers = this.user.linkedInstagramList.filter(
        (l) => l.isUnlimited && !l.isMember && l.status !== 2
      );
      const memberPublishers = this.user.linkedInstagramList.filter(
        (l) => l.isMember && l.status !== 2
      );
      if (unlimitedPublishers.length > 0) {
        types.push({
          title: this.$t("addUnlimitedAccountPage.normalUnlimitedUserType"),
          items: unlimitedPublishers,
        });
      }
      if (memberPublishers.length > 0) {
        types.push({
          title: this.$t("addUnlimitedAccountPage.memberUserType"),
          items: memberPublishers,
        });
      }
      if (limitedPublishers.length > 0) {
        types.push({
          // title: this.$t('addUnlimitedAccountPage.freeUserType'),
          title: "",
          items: limitedPublishers,
        });
      }
      return types;
    },
  },
  data() {
    return {
      selectPublisherId: this.model,
      showLoginDialog: false,
      platformModal: false,
    };
  },
  methods: {
    showAddInsUser() {
      this.$bus.$emit("showAddIns", {});
    },
    itemClick(item) {
      this.selectPublisherId = item.publisherId;
      this.$emit("updateValue", item.publisherId);
    },
    /**
     * 添加点击事件
     */
    addInsBtnClick() {
      this.show = false;
      this.platformModal = false;
      this.$bus.$emit("showAddIns", {});
    },
    addFbPageBtnClick() {
      this.show = false;
      this.platformModal = false;
      this.$bus.$emit("showAddFacebookPage", { homeLogin: true });
    },
    addFbGroupBtnClick() {
      this.show = false;
      this.platformModal = false;
      this.$bus.$emit("showAddFacebookGroup", {});
    },
    addTwitterBtnClick() {
      this.show = false;
      this.platformModal = false;
      this.$bus.$emit("showAddTwitter", {});
    },
  },
  created() {
    // 如果没有选择，则默认选第一个
    if (!this.selectPublisherId) {
      const first = this.all[0].items[0];
      this.itemClick(first);
    }
  },
};
</script>
<style scoped lang="less">
@import "../../../assets/style/theme.less";
.platform-list-container {
  padding: 10px 0;
  .platform-item {
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
    .icon {
      height: 22px;
      width: 22px;
      background-size: contain;
      &.ins {
        background-image: url("../../../../public/images/common/list_ins@3x.png");
      }
      &.fb {
        background-image: url("../../../../public/images/common/list_fb@3x.png");
      }
      &.fb-group {
        background-image: url("../../../../public/images/common/list_fb_group@3x.png");
      }
      &.twitter {
        background-image: url("../../../../public/images/common/list_twitter@3x.png");
      }
    }
    .right-icon {
      height: 18px;
      width: 10px;
      background-size: contain;
      background-image: url("../../../../public/images/schedule_posts/Date_Right@3x.png");
    }
    .text {
      flex: 1;
      padding-left: 10px;
      font-size: 16px;
    }
  }
}
.instagram-container {
  border-right: 1px solid @border-color;
  width: 300px;
  display: flex;
  flex-direction: column;

  .header-title {
    font-size: 18px;
    height: 80px;
    display: flex;
    align-items: center;
    font-weight: 500;
    padding-left: 20px;
    border-bottom: 1px solid @border-color;
  }

  .list-container {
    overflow: auto;
    height: calc(100vh - 140px);
    .type-list {
      border-bottom: 1px solid @border-color;
    }
  }

  .bottom-container {
    height: 65px;
    border-top: 1px solid @border-color;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .type-title {
    font-size: 16px;
    font-weight: 500;
    margin: 13px 0;
    padding: 0 23px;
  }
}
.add-icon {
  background-image: url("../../../../public/images/common/add_ins.png");
  width: 18px;
  height: 18px;
  background-size: contain;
  margin-right: 6px;
  position: relative;
  bottom: 1px;
}
.add-btn {
  display: flex;
  align-items: center;
  color: #e72955;
  font-size: 16px;
  cursor: pointer;
}
</style>
